import { Navigate } from 'react-router-dom';
import { useBrandFeatures, type BrandFeatures } from '@/hooks/useBrandFeatures';
import { useBrand } from '@/hooks/useBrand';
import { PageLoader } from '@/components/layout/PageLoader';

interface FeatureRouteProps {
  feature: keyof BrandFeatures;
  children: React.ReactNode;
}

/**
 * Route guard that redirects to /dashboard when a brand-level feature is disabled.
 *
 * Waits for the brand context to finish loading before deciding — otherwise a direct
 * navigation or refresh evaluates the flag against DEFAULT_FEATURES (everything off)
 * before the active brand resolves and bounces the user to the dashboard.
 */
export function FeatureRoute({ feature, children }: FeatureRouteProps) {
  const { isLoading } = useBrand();
  const features = useBrandFeatures();

  if (isLoading) {
    return <PageLoader />;
  }

  if (!features[feature]) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
